/* eslint-disable ember/no-classic-components, ember/require-tagless-components, no-restricted-properties, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import moment from 'moment';

export default class AttendanceMovements extends Component {
  @service
  attendanceCodes;

  @service
  toaster;

  date = '';
  periods = [];
  records = [];

  // hasMovements is a native getter rather than a computed. `movements` is a
  // fragmentArray, so an intermediary CP keyed one level deep
  // (`records.@each.movements`) would go stale, because model-fragments does
  // not notify the owning `records` key when a nested fragmentArray gains or
  // loses members. Iterating here consumes the nested membership tag via
  // autotracking, so this recomputes correctly.
  get hasMovements() {
    if (isEmpty(this.records)) {
      return false;
    }
    return this.records.some((record) => {
      return !isEmpty(record.movements) && record.movements.length > 1;
    });
  }

  showLog = false;

  @tracked
  editDialogOpen = false;

  @tracked
  deleteDialogOpen = false;

  @tracked
  reason = '';

  @action
  setReason(value) {
    this.reason = value;
  }

  @tracked
  code = '';

  @tracked
  notes = '';

  @action
  setNotes(value) {
    this.notes = value;
  }

  @tracked
  time = '';

  @tracked
  saveInProgress = false;

  @tracked
  movement = null;

  @tracked
  record = null;

  @tracked
  deleteInProgress;

  @action
  noOp() {}

  @action
  edit(movement, record) {
    this.movement = movement;
    this.record = record;
    this.reason = '';
    this.code = movement.code;
    this.notes = movement.notes;
    this.time = moment.unix(movement.time).format('HH:mm');
    this.editDialogOpen = true;
  }

  @action
  changeCode(newCode) {
    this.code = newCode.code;
  }

  @action
  closeEditDialog() {
    this.editDialogOpen = false;
  }

  @action
  save() {
    this.saveInProgress = true;
    let reason = this.reason;
    if (this.code === this.movement.code) {
      // If the code didn't change, only the notes were updated.
      reason = `Updated note from "${this.movement.notes}"`;
    }
    // Use the movement's time as effectiveFrom so that the back end can find
    // the matching movement to update.
    this.record.setProperties({
      effectiveFrom: this.movement.time,
      reason,
    });
    this.movement.setProperties({
      code: this.code,
      notes: this.notes,
    });
    this.record
      .save()
      .then(() => {
        this.toaster.success('Attendance Movement updated successfully!');
        this.editDialogOpen = false;
      })
      .catch(() => {
        this.toaster.error('Error updating Attendance Movement!');
      })
      .finally(() => {
        this.saveInProgress = false;
      });
  }

  @action
  delete(movement, record) {
    this.movement = movement;
    this.record = record;
    this.reason = '';
    this.deleteDialogOpen = true;
  }

  @action
  doDelete() {
    this.deleteInProgress = true;
    this.record.setProperties({
      effectiveFrom: this.movement.time,
      reason: this.reason,
    });
    this.record.movements.removeObject(this.movement);
    this.record
      .save()
      .then(() => {
        this.toaster.success('Attendance Movement deleted successfully!');
        this.deleteDialogOpen = false;
      })
      .catch(() => {
        this.toaster.error('Error deleting Attendance Movement!');
      })
      .finally(() => {
        this.deleteInProgress = false;
      });
  }

  @action
  closeDeleteDialog() {
    this.deleteDialogOpen = false;
  }
}
